import React, { useEffect, useContext } from 'react';
import { Loading } from 'components/Loading';

import {
  StyledCardsSeparator,
  StyledLoading,
  StyledWrapper,
} from 'modules/assignment-cards/styled';

import PrebookingCard from './card';
import PrebookingAssignmentContext from './context';

const t = {
  occupied: 'Occupied',
};

const isFree = (prebooking) => {
  return !(prebooking || {}).is_completed;
};

const isNotFree = (prebooking) => {
  return !isFree(prebooking);
};

const AssignmentPrebookings = ({ filters, vertical, assignActionComponent }) => {
  const { clear, loading, prebookings, fetchPrebookings } = useContext(PrebookingAssignmentContext);

  useEffect(() => {
    if (!filters) {
      return;
    }
    fetchPrebookings(filters);
    return () => {
      clear();
    };
  }, [fetchPrebookings, clear, filters]);

  if (!filters) {
    return null;
  }

  if (loading) {
    return (
      <StyledLoading>
        <Loading />
      </StyledLoading>
    );
  }

  const freePrebookings = prebookings.filter(isFree);
  const notFreePrebookings = prebookings.filter(isNotFree);

  return (
    <StyledWrapper vertical={vertical} data-testid="AssignmentPrebookings">
      {freePrebookings.map(({ id }, key) => (
        <PrebookingCard
          key={id}
          id={id}
          isFirst={key === 0}
          assignActionComponent={assignActionComponent}
          vertical={vertical}
        />
      ))}
      {!!notFreePrebookings.length && (
        <StyledCardsSeparator>
          <span>{t.occupied}</span>
        </StyledCardsSeparator>
      )}
      {notFreePrebookings.map(({ id }) => (
        <PrebookingCard key={id} id={id} backgroundSkin="grey800" />
      ))}
    </StyledWrapper>
  );
};

export default AssignmentPrebookings;
